
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../Store';

import { useGetOwnTwoPhaseImageMutation } from '../../api/ProfileAPI';
import styles from './landingpage.module.scss';

export default function LandingPageAdmin() {

    //const dispatch = useDispatch<AppDispatch>();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const auth = useSelector((state: RootState) => state.authSlice.auth);
    const [image, setImage] = useState<string>("");

    const [own2factorimage] = useGetOwnTwoPhaseImageMutation();

    useEffect(() => {

        own2factorimage().then((res) => {
            setImage("data:image/png;base64, " + res.data);
        })

    }, [])


    return (
        <>
            <div className="container">

                <h3>{t('deTranslation.landingPageAdmin.titel')}</h3>

                <div className={styles.cardContainer} >

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/profiles/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-person"}></i> Profile
                        </span>
                    </div>

                     <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/parameter/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-currency-euro"}></i> Parameter
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/auftraggeber/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-building"}></i> Auftraggeber
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/rechnungsempfaenger/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-receipt"}></i> Rechnungsempfänger
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/dienstleistung/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-rulers"}></i> Dienstleistungen
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/mwstsatz/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-percent"}></i> Mwst Satz
                        </span>
                    </div>

                    <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/preise/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-currency-euro"}></i> Preise
                        </span>
                    </div>

                     <div className={"card " + styles.landingPageCard} onClick={() => navigate("/admin/papierkorb/")}>
                        <span className={styles.landingPageCardSpan}>
                            <i className={"bi bi-trash"}></i> Papierkorb
                        </span>
                    </div>

                </div>

                <div className={"card " + styles.landingPageCard} onClick={() => { }} style={{ marginTop: "2em" }}>
                    <span className={styles.landingPageCardSpan}>
                        <img src={image} />
                    </span>
                </div>
            </div>
        </>
    );
}
